export default __webpack_public_path__ + "static/media/mz.aae0a6a0.svg";